import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, Route } from '@angular/router';
import {
  DynamicDialogRef,
  DialogService,
  DynamicDialogConfig,
} from 'primeng/dynamicdialog';
import {
  InstituicaoEnsinoService,
  PaisService,
  ProvinciaService,
  MunicipioService,
  CommunicationService,
  TipoInstituicaoEnsinoService,
  RepresentacaoInstituicaoEnsinoService,
  EnumService,
} from '../../api/services';
import { Subscription, forkJoin } from 'rxjs';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { CadastroIntituicaoEnsinoComponent } from '../cadastro-intituicao-ensino/cadastro-intituicao-ensino.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ApiService } from '@core/providers/http';
import { ToastModule } from 'primeng/toast';
import { InstituicoesEnsinoListarCursosComponent } from '../instituicoes-ensino-cursos/instituicoes-ensino-listar-cursos/instituicoes-ensino-listar-cursos.component';
import { InstituicoesEnsinoListarBolseirosComponent } from '../instituições-ensino-bolseiros/instituicoes-ensino-listar-bolseiros/instituicoes-ensino-listar-bolseiros.component';
import { RepresentanteCardComponent } from '../add-representante/components/representante-card/representante-card.component';
import { Pagination } from '@app/shared/model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import {
  Bolseiro,
  InstituicaoEnsino,
  RepresentacaoInstituicaoEnsino,
} from '../../api/models';
import { DrawerModule } from 'primeng/drawer';
import { MaisDetalhesIntituicaoEnsinoComponent } from '../lista-instituicoes-ensino/mais-detalhes-intituicao-ensino/mais-detalhes-intituicao-ensino.component';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { CardPersonBolseirosComponent } from '@app/shared/components/card-person-bolseiros/card-person-bolseiros.component';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { UnidadeOrganicaComponent } from '../unidade-organica-components/unidade-organica/unidade-organica.component';
import { UnidadeOrganicaListComponent } from '../unidade-organica-components/unidade-organica-list/unidade-organica-list.component';
import { EditRepresentanteComponent } from '../add-representante/components/edit-representante/edit-representante.component';
import { TagModule } from 'primeng/tag';
import { FilterItem } from '../../api/models/filterItem.model';
import { RedefinirSenhaComponent } from '@app/shared/components/redefinir-senha/redefinir-senha.component';
import { FormGroup, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';
import { AuthStore } from '@core/service/auth-store.service';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-perfil-instituicao-ensino',
  templateUrl: './perfil-instituicao-ensino.component.html',
  styleUrls: ['./perfil-instituicao-ensino.component.scss'],
  imports: [
    CommonModule,
    BackButtonComponent,
    ButtonModule,
    DialogModule,
    SelectModule,
    InputText,
    TabsModule,
    InstituicoesEnsinoListarCursosComponent,
    InstituicoesEnsinoListarBolseirosComponent,
    RepresentanteCardComponent,
    PaginatorControlComponent,
    ToastModule,
    DrawerModule,
    ReactiveFormsModule,
    MaisDetalhesIntituicaoEnsinoComponent,
    SearchBarComponent,
    CardPersonBolseirosComponent,
    ConfirmDialog,
    UnidadeOrganicaListComponent,
    DataVoidComponent,
    EditRepresentanteComponent,
    TagModule,
    AvatarModule,
  ],
  providers: [
    ApiService,
    InstituicaoEnsinoService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    CommunicationService,
    TipoInstituicaoEnsinoService,
    RepresentacaoInstituicaoEnsinoService,
    DialogService,
    MessageService,
    ConfirmationService,
    EnumService,
    DynamicDialogConfig,
    DynamicDialogRef,
  ],
  standalone: true,
})
export class PerfilInstituicaoEnsinoComponent implements OnInit, OnDestroy {
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
  private route = inject(ActivatedRoute);
  private auth = inject(AuthStore);
  router = inject(Router);
  private enumService = inject(EnumService);
  private dialogService = inject(DialogService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private paisService = inject(PaisService);
  private provinciaService = inject(ProvinciaService);
  private municipioService = inject(MunicipioService);
  private communicationService = inject(CommunicationService);
  private tipoInstituicaoEnsinoService = inject(TipoInstituicaoEnsinoService);
  private instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  private representacaoInstituicaoEnsinoService = inject(
    RepresentacaoInstituicaoEnsinoService
  );
  isLoading: boolean = false;
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  typeofEducationalInstitution: any[] = [];
  naturezaOptions: any[] = [];
  educationalInstitution: any[] = [];
  form!: FormGroup;
  instituicoes: any[] = [];
  private subscriptions = new Subscription();
  profileEducationalInstitution: any;
  courseCount = 0;
  estudanteCount = 0;
  activeTab: number = 0;
  ref: DynamicDialogRef | undefined;
  pagination: Pagination<any> = new Pagination<any>();
  MenuTable: MenuItem[] | undefined;
  @Output() onCloseModal = new EventEmitter<boolean>();
  maisDetalheInstituicao: InstituicaoEnsino | undefined | null;
  showDetalhe: boolean = false;

  instituicaoEnsinoID!: string;
  idInstituicao!: number;
  filters: FilterItem[] = [
    { type: 'text', controlName: 'Nome', placeholder: 'Pesquise por nome' },
    { type: 'text', controlName: 'EmailRepresentante', placeholder: 'Pesquise por email' },
    { type: 'text', controlName: 'Telefone', placeholder: 'Pesquise por telefone' },
  ];
  representanteList: RepresentacaoInstituicaoEnsino[] = [];
  imagePreview: string | ArrayBuffer | null = null;
  fotoPreviewMap: { [id: number]: string | ArrayBuffer | null } = {};
  selectedInstitucao: any | null = null;

  constructor(private fb: FormBuilder) {
    this.loadCountries();
  }

  @ViewChild(UnidadeOrganicaListComponent)
  private ListaUnidadesOrganicaCmp!: UnidadeOrganicaListComponent;

  @ViewChild(InstituicoesEnsinoListarCursosComponent)
  private ListaCursosCmp!: InstituicoesEnsinoListarCursosComponent;

  @ViewChild(InstituicoesEnsinoListarBolseirosComponent)
  private ListaBolseirosCmp!: InstituicoesEnsinoListarBolseirosComponent;

  ngOnInit(): void {
    this.instituicaoEnsinoID = this.route.snapshot.paramMap.get('id')!;
    if (!this.instituicaoEnsinoID) {
      console.error('ID da instituição de ensino não encontrado na rota.');
      return;
    }

    this.loadInstitutionDetails(this.instituicaoEnsinoID);
    this.loadImagemInstituicao(Number(this.instituicaoEnsinoID));

    this.route.params.subscribe((params) => {
      this.idInstituicao = +params['id'];
      this.loadAllRepresentantes();
    });

    this.loadEnums();

    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe((country: string | null) => {
        if (country) this.loadProvinces(country);
      })
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe((province: string | null) => {
        if (province) this.loadMunicipalities(province);
      })
    );

    this.MenuTable = [
      { label: 'Editar', icon: 'pi pi-pencil' },
      { label: 'Excluir', icon: 'pi pi-trash' },
    ];

    this.form = this.fb.group({
      Nome: [null],
      EmailRepresentante: [null],
      Telefone: [null],
    });
  }

  get instituicaoEnsinoId(): any {
    return this.route.snapshot.paramMap.get('id');
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  // ─── Tabs ────────────────────────────────────────────────────────────────────

  onTabClick(tabIndexOrEvent: number | Event) {
    const nextIdx =
      typeof tabIndexOrEvent === 'number' ? tabIndexOrEvent : this.activeTab;

    // Ao SAIR da tab de cursos (1), fecha todos os accordions e limpa a lista.
    // Assim quando o utilizador regressar encontra tudo fechado e sem dados stale.
    if (this.activeTab === 1 && nextIdx !== 1) {
      this.ListaCursosCmp?.resetAccordion();
    }

    switch (nextIdx) {
      case 0:
        this.ListaUnidadesOrganicaCmp?.loadAllUnidadeOrganica();
        break;

      case 1:
        // Se já há unidades orgânicas, o accordion trata do carregamento ao abrir.
        // Se não há (view simples), carrega directamente.
        if (!this.ListaCursosCmp?.paginationUnidadeOrganica?.data?.length) {
          this.ListaCursosCmp?.loadCursosByInstituicaoEnsino(
            Number(this.instituicaoEnsinoID)
          );
        }
        break;

      case 2:
        this.ListaBolseirosCmp?.loadBolseirosByInstituicaoEnsino(
          Number(this.instituicaoEnsinoID)
        );
        break;

      case 3:
        this.loadAllRepresentantes();
        break;
    }
  }

  // ─── Instituição ─────────────────────────────────────────────────────────────

  toggleStatus(): void {
    const id = this.instituicaoEnsinoID;
    if (!id) return;

    const newStatus = !this.profileEducationalInstitution?.isActive;

    this.confirmationService.confirm({
      message: `Tens a certeza que queres ${newStatus ? 'ativar' : 'desativar'} esta instituição?`,
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.instituicaoEnsinoService.toggleStatus(id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: `Instituição ${newStatus ? 'ativada' : 'desativada'} com sucesso!`,
              life: 3000,
            });
            this.loadInstitutionDetails(id);
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao alterar o status da instituição.',
              life: 3000,
            });
            console.error('Erro ao alterar status:', error);
          },
        });
      },
    });
  }

  getPhoneWithCountryCode(): string {
    const ddiMap: { [key: string]: string } = { Angola: '+244' };
    const tel = this.profileEducationalInstitution?.telefone || '';
    const pais = this.profileEducationalInstitution?.pais || '';
    const ddi = ddiMap[pais] || '';
    if (tel.startsWith(ddi)) return tel;
    return ddi ? `${ddi} ${tel}` : tel;
  }

  loadAllRepresentantes(queryParams?: any) {
    const params = {
      ...queryParams,
      instituicaoEnsinoID: this.instituicaoGestoraID,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };
    this.representacaoInstituicaoEnsinoService.list(params).subscribe({
      next: (response) => {
        this.representanteList = response.data;
        this.pagination = new Pagination<any>().deserialize(response);
        this.representanteList.forEach((repre: any) => {
          if (repre.id) this.loadRepresentanteEnsinoimage(repre.id);
        });
      },
      error: (error) => {
        console.error('Erro ao carregar representantes:', error);
      },
    });
  }

  get instituicaoGestoraID(): any {
    return this.route.snapshot.paramMap.get('id');
  }

  loadRepresentanteEnsinoimage(id: number) {
    this.representacaoInstituicaoEnsinoService
      .getFotoRepresentacaoInstituicaoEnsinoById(id)
      .subscribe({
        next: (response) => {
          if (!response || !response.type.startsWith('image/')) {
            this.fotoPreviewMap[id] = null;
            return;
          }
          const reader = new FileReader();
          reader.onload = () => { this.fotoPreviewMap[id] = reader.result; };
          reader.readAsDataURL(response);
        },
        error: () => { this.fotoPreviewMap[id] = null; },
      });
  }

  deleteRepresentante(representante: any) {
    this.confirmationService.confirm({
      header: 'Confirmar Exclusão?',
      message: `Tem certeza que deseja excluir ${representante?.nome}?`,
      icon: 'pi pi-exclamation-circle',
      rejectButtonProps: { label: 'Cancelar', icon: 'pi pi-times', outlined: true, size: 'small' },
      acceptButtonProps: { icon: 'pi pi-trash', label: 'Sim', size: 'small' },
      accept: () => {
        this.representacaoInstituicaoEnsinoService.delete(representante.id).subscribe(() => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Representante excluído com sucesso!',
            life: 3000,
          });
          this.loadAllRepresentantes();
        });
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Cancelada', detail: 'Exclusão cancelada' });
      },
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadAllRepresentantes();
  }

  actionClick(instituicaoEnsino: InstituicaoEnsino) {
    this.maisDetalheInstituicao = instituicaoEnsino;
    this.showDetalhe = true;
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  setCourseCount(count: number) {
    this.courseCount = count;
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => { this.countries = countries; });
  }

  loadEnums() {
    forkJoin({
      naturezaInstituicao: this.enumService.getAllNaturezaInstituicaoEnum(),
      tipoInstituicao: this.enumService.getAllTipoInstituicaoEnum(),
    }).subscribe((response: any) => {
      if (response.naturezaInstituicao?.data) {
        this.naturezaOptions = Object.entries(response.naturezaInstituicao.data).map(
          ([key, value]) => ({ id: Number(key), designacao: value })
        );
      }
      if (response.tipoInstituicao?.data) {
        this.typeofEducationalInstitution = Object.entries(response.tipoInstituicao.data).map(
          ([key, value]) => ({ id: Number(key), designacao: value })
        );
      }
    });
  }

  loadProvinces(country: string) {
    if (!country) return;
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = [];
    });
  }

  loadMunicipalities(province: string) {
    if (!province) return;
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  getAllInstituicoesEnsino() {
    this.instituicaoEnsinoService.list().subscribe((institutions) => {
      this.educationalInstitution = institutions;
    });
  }

  loadInstitutionDetails(instituicaoEnsinoID: string): void {
    this.instituicaoEnsinoService.show(instituicaoEnsinoID).subscribe((data: any) => {
      this.profileEducationalInstitution = data;
      this.loadProvinces(this.profileEducationalInstitution?.paisID);
      this.loadMunicipalities(this.profileEducationalInstitution?.provinciaID);
    });
  }

  loadImagemInstituicao(id: number) {
    this.instituicaoEnsinoService.getFotoInstituicaoById(id).subscribe({
      next: (response) => {
        if (!response || !response.type.startsWith('image/')) {
          this.imagePreview = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = () => { this.imagePreview = reader.result; };
        reader.readAsDataURL(response);
      },
      error: () => { this.imagePreview = null; },
    });
  }

  showDialog(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) return;

    const ref = this.dialogService.open(CadastroIntituicaoEnsinoComponent, {
      header: 'Editar instituição',
      width: '45%',
      showHeader: false,
      modal: true,
      data: {
        profileEducationalInstitution: this.profileEducationalInstitution,
        countries: this.countries,
        provinces: this.provinces,
        municipalities: this.municipalities,
        typeofEducationalInstitution: this.typeofEducationalInstitution,
        naturezaOptions: this.naturezaOptions,
        imagePreview: this.imagePreview,
        isEditMode: true,
      },
    });

    ref.onClose.subscribe((data) => {
      if (!(data instanceof FormData)) return;

      this.confirmationService.confirm({
        header: 'Confirmar Edição?',
        message: `Tens a certeza que queres actualizar os dados de ${this.profileEducationalInstitution?.nome}?`,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sim, salvar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.isLoading = true;
          this.instituicaoEnsinoService.update(data, id).subscribe({
            next: () => {
              this.isLoading = false;
              this.loadInstitutionDetails(id);
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Instituição de Ensino actualizada com sucesso!',
                life: 3000,
              });
            },
            error: (error) => {
              this.isLoading = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: error.error?.retorno?.mensagem || 'Erro ao actualizar instituição.',
                life: 3000,
              });
            },
          });
        },
        reject: () => {
          this.messageService.add({ severity: 'info', summary: 'Cancelado', detail: 'Edição cancelada.', life: 2000 });
        },
      });
    });
  }

  deleteInstitution(instituicaoEnsinoId: string): void {
    if (!instituicaoEnsinoId) return;

    this.confirmationService.confirm({
      header: 'Eliminar Instituição de Ensino?',
      message: `A instituição ${this.profileEducationalInstitution?.nome ?? 'selecionada'} será eliminada permanentemente. Deseja continuar?`,
      icon: 'pi pi-exclamation-circle',
      rejectButtonProps: { label: 'Cancelar', icon: 'pi pi-times', outlined: true, size: 'small' },
      acceptButtonProps: { icon: 'pi pi-trash', label: 'Sim, eliminar', severity: 'danger', size: 'small' },
      accept: () => {
        this.isLoading = true;
        this.instituicaoEnsinoService.delete(instituicaoEnsinoId).subscribe({
          next: () => {
            this.isLoading = false;
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Instituição eliminada com sucesso!',
              life: 3000,
            });
            setTimeout(() => {
              this.router.navigate(['gestao-bolseiros/instituicao-ensino']);
            }, 2000);
          },
          error: (error: any) => {
            this.isLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: error.error?.retorno?.mensagem || 'Erro ao eliminar instituição.',
              life: 3000,
            });
          },
        });
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Cancelado', detail: 'Operação cancelada.', life: 2000 });
      },
    });
  }

  CreateOrgUnit(instituicaoEnsinoId: string): void {
    this.dialogService.open(UnidadeOrganicaComponent, {
      header: 'Adicionar Unidade Orgânica',
      width: '45%',
      showHeader: false,
      modal: true,
      data: {
        instituicaoEnsinoId,
        typeofEducationalInstitution: this.typeofEducationalInstitution,
        naturezaOptions: this.naturezaOptions,
      },
    });
  }

  verEstudante(representante: any) {
    this.showDetalhe = true;
  }

  editarRepresentante(representante: any) {
    const ref = this.dialogService.open(EditRepresentanteComponent, {
      header: 'Editar Representante',
      width: '45%',
      showHeader: false,
      modal: true,
      data: { representante },
    });

    ref.onClose.subscribe((data) => {
      if (data instanceof FormData) {
        this.isLoading = true;
        this.representacaoInstituicaoEnsinoService.update(data).subscribe({
          next: () => {
            this.loadAllRepresentantes();
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Representante actualizado com sucesso!' });
            this.isLoading = false;
          },
          error: (error) => {
            this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao actualizar representante.' });
            this.isLoading = false;
          },
        });
      }
    });
  }

  notificarRepresentante(representante: any) {}

  redefinirSenhaRepresentante(representante: any) {
    const ref = this.dialogService.open(RedefinirSenhaComponent, {
      header: 'Redefinir Senha do Representante',
      width: '45%',
      showHeader: false,
      modal: true,
      data: { representante },
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Senha redefinida',
          detail: `Senha redefinida para o usuário ${data.username}.`,
        });
      }
    });
  }

  addRepresentante(): void {
    if (!this.instituicaoEnsinoID) {
      console.error('ID da instituição de ensino não definido.');
      return;
    }
    this.router.navigate([
      '/gestao-bolseiros/instituicao-ensino/add-representante',
      this.instituicaoEnsinoID,
    ]);
  }

  trackByBolseiroId(index: number, item: Bolseiro): number {
    return item.id;
  }

  units = [
    { name: 'ISAF', subject: 'Contabilidade', status: 'Activo' },
    { name: 'FEUCAN', subject: 'Engenharia', status: 'Inactivo' },
    { name: 'FLUAN', subject: 'Pedagogia', status: 'Activo' },
  ];

  showFilter = false;

  showFilterModal() {
    this.showFilter = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.pagination.pageNumber = 1;
    this.loadAllRepresentantes(filters);
    this.showFilter = false;
  }
}